<template>
  <div class="ws-col">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>